export const LUBRICANT_CHEMICAL = 'bltbd9459ed50b764d7';
export const FILTER = 'blt5824ad9285b09f71';
export const BRAKE_SUSPENSION = 'blt26a4d9191cb49350';
export const BATTERY_TIRE = 'blt0ce5dc819800dc9c';
export const PREVENTIVE_MAINTENANCE = 'blt3d01f2afa22ac69c';
export const TIRE_ENTRY = 'blt9378e487e6c0465a';
